import { LogOut, User } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const UserHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2 px-3 py-2 bg-white rounded-lg border border-slate-200">
        <User className="w-4 h-4 text-slate-600" />
        <span className="text-sm font-medium text-slate-700">{user?.name}</span>
        <span className="text-xs text-slate-500">({user?.role})</span>
      </div>
      <button
        onClick={handleLogout}
        data-testid="logout-button"
        className="flex items-center gap-2 px-3 py-2 bg-rose-600 text-white rounded-lg hover:bg-rose-700 transition-colors text-sm font-medium"
      >
        <LogOut className="w-4 h-4" />
        Logout
      </button>
    </div>
  );
};

export default UserHeader;
